// extracted by mini-css-extract-plugin
export var author = "menuCompany-module--author--3200a";
export var category = "menuCompany-module--category--d8c1c";
export var companyLinks = "menuCompany-module--company-links--1b46d";
export var headline = "menuCompany-module--headline--919c4";
export var headlinePost = "menuCompany-module--headline-post--8a306";
export var itemsGrid = "menuCompany-module--itemsGrid--cc6cf";
export var itemsWrapper = "menuCompany-module--itemsWrapper--5fca3";
export var lastCol = "menuCompany-module--lastCol--9119d";
export var paragraph = "menuCompany-module--paragraph--45f1c";